// @ts-expect-error no types exported
import { FeedbackLoaderProvider } from 'feedback-loader/FeedbackLoaderProvider';
import { useTaskApi } from 'setup-guide-api/hooks/task';
import AddonComponentsContext from 'setup-guide-components/contexts/AddonComponentsContext';
import AuthContext from 'setup-guide-components/contexts/AuthContext';
import TaskApiContext from 'setup-guide-components/contexts/TaskApiContext';
import TaskDataContext from 'setup-guide-components/contexts/TaskDataContext';
import TrackerContext from 'setup-guide-components/contexts/TrackerContext';
import ExperimentContext from 'setup-guide-components/contexts/ExperimentContext';
import UserGuideManualDetectedTaskButtons from 'setup-guide-components/components/checklist/internal/ManualDetectedTaskButtons';
import ViewConfigContext from 'setup-guide-components/contexts/ViewConfigContext';
import NavigationContext from 'setup-guide-components/contexts/NavigationContext';
import { TaskCardsContextProvider } from 'setup-guide-components/contexts/TaskCardsContext';
import { CmsManualDetectedTaskButtons } from 'cms-onboarding-lib/components/checklist/task/CmsManualDetectedTaskButtons';
import InviteSeatsContext from 'growth-invite-components/contexts/InviteSeatsContext';
import { useInviteSeats } from 'growth-invite-components/hooks/useInviteSeats';
import PortalContactsContext from 'setup-guide-components/contexts/PortalContactsContext';
import { usePortalContactsCount } from 'setup-guide-components/hooks/portalContacts';
import ComposeProviders from './ComposeProviders';
import HandholdingBannerHelpers from './HandholdingBannerHelpers';
import { useAuthData } from '../hooks/auth';
import { useExperiments } from '../hooks/experiments/common';
import { useViewConfig } from 'setup-guide-config/hooks/config';
import { useTaskDataInUserGuide } from '../hooks/task';
import { trackPageView, trackSectionView, trackTaskInteraction, trackUserInteraction, trackExploreCardInteraction } from '../utils/usageTracker';
import { getTracker } from '../utils/tracker';
import LogExposureContext from 'setup-guide-components/contexts/LogExposureContext';
import { logExposure } from '../api/experimentsApis';
import { useSetSelectedTabView } from '../hooks/config';
import { jsx as _jsx } from "react/jsx-runtime";
const trackerContext = {
  tracker: getTracker(),
  trackPageView,
  trackSectionView,
  trackTaskInteraction,
  trackUserInteraction,
  trackExploreCardInteraction
};
const logExposureContext = {
  logExposure
};
const SetupGuideContextsProvider = ({
  children
}) => {
  const authContext = useAuthData();
  const addonComponentsContext = {
    HandholdingBannerHelpers,
    ManualDetectedTaskButtons: Object.assign({}, UserGuideManualDetectedTaskButtons, CmsManualDetectedTaskButtons)
  };
  return /*#__PURE__*/_jsx(ComposeProviders, {
    providers: [[TrackerContext, trackerContext], [AddonComponentsContext, addonComponentsContext], [AuthContext, authContext], [TaskApiContext, useTaskApi()], [TaskDataContext, useTaskDataInUserGuide()], [ExperimentContext, useExperiments()], [InviteSeatsContext, useInviteSeats()], [PortalContactsContext, usePortalContactsCount()], [LogExposureContext, logExposureContext], [ViewConfigContext, useViewConfig({
      authContext
    })], [NavigationContext, {
      setSelectedTabView: useSetSelectedTabView()
    }], [TaskCardsContextProvider], [FeedbackLoaderProvider]],
    children: children
  });
};
export default SetupGuideContextsProvider;